<template>
  <div>
    <div>
      <!-- 头部-->
      <div class="fr ac bg_white" style="height: 100px">
        <div style="margin-left: 242px">
          <img
            class="cursor"
            @click="go('/home/index')"
            style="width: 114px;height: 60px"
            src="/static/imgs/home/logo.png"
            alt
          />
        </div>
        <div style="margin-left: 38px;font-size: 30px">欢迎登录</div>
      </div>

      <!--    中间-->

      <div
        class="fc jc ac bg_white p30"
        style="width: 1200px;margin: 20px auto"
      >
        <div class="protocol p30">
          <!--      协议内容-->
          <div>
            <div class="fr jc ac fz18 mt30">{{ protocol.html_name }}</div>
            <div class="mt40 fz12" v-html="protocol.html_url_desc"></div>
          </div>

          <div class="fr jc ac mt40">
            <div
              v-if="!show_count_down"
              @click="agree"
              class="agree white fr jc ac cursor"
            >
              我同意
            </div>
            <div
              v-if="show_count_down"
              class="agree white fr jc ac"
              style="cursor: not-allowed"
            >
              我同意({{ times }})
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--  底部  -->
    <footer-bar></footer-bar>
  </div>
</template>

<script>
import FooterBar from "../../components/FooterBar";

export default {
  data() {
    return {
      protocol: {
        html_id: "",
        html_name: "用户注册及隐私协议",
        html_url_desc:
          "12233333333333;skfjlasjflajs;lfj;lajsl;fj;la了;发了睡觉了;发送机",
      },
      show_count_down: true,
      times: 10,
    };
  },
  mounted() {
    let param = this.$route.query;
    this.protocol.html_id = param.html_id;
    this.getHtmlDetail(param.html_id);

    //  显示倒计时

    let i = setInterval(() => {
      this.times--;

      if (this.times <= 0) {
        clearInterval(i);
        this.show_count_down = false;
        this.times = 30;
      }
    }, 1000);
  },
  methods: {
    agree() {
      let param = {
        html_id: this.protocol.html_id,
      };

      this.$message("阅读成功");
      this.go("/home/index");
      // this.post(
      //   "settingInterfaces/v1.0/insertMemberHtml",
      //   param
      // ).then((res) => {});
    },
    //获取详情
    getHtmlDetail(html_id) {
      let param = {
        html_id: html_id,
      };
      this.post("settingInterfaces/v1.0/getHtmlDetail", param).then((res) => {
        this.protocol = res.data;
      });
    },
  },
  components: {
    "footer-bar": FooterBar,
  },
};
</script>

<style scoped lang="scss">
.protocol {
  width: 1000px;
  // height: 562px;
  background: rgba(242, 242, 242, 1);
  opacity: 1;
}

.agree {
  width: 241px;
  height: 40px;
  background: rgba(69, 142, 246, 1);
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/page/register/Protocol.vue